<template>
  <div :class="{ mobile: mobile }">
    <Carousel dots="none" class="my-swiper" loop v-if="list && list.length">
      <CarouselItem v-for="(item, index) in list" ::key="index">
        <img :src="item.url" style="width: 100%">
      </CarouselItem>
    </Carousel>
    <div class="formbox">
      <h4>基本信息</h4>
      <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="top" @submit.native.prevent class="my-form">
        <FormItem label="姓名：" prop="name">
          <Input v-model="formInline.name" placeholder="请输入姓名" />
        </FormItem>
        <FormItem label="性别：" prop="gender">
          <Select v-model="formInline.gender" placeholder="请选择性别">
            <Option value="male">男</Option>
            <Option value="female">女</Option>
            <Option value="unknown">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="公司名称：" prop="companyName">
          <Input v-model="formInline.companyName" placeholder="请输入公司名称" />
        </FormItem>
        <FormItem label="部门：" prop="department">
          <Select v-model="formInline.department" placeholder="请选择部门" @on-change="changeJobs">
            <Option :value="item.name" :key="'dep-' + index" v-for="(item, index) in departmentArr">{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="职务：" prop="jobTitle">
          <Select v-model="formInline.jobTitle" placeholder="请选择职务">
            <Option :value="item.name" :key="'job-' + index" v-for="(item, index) in jobTitleArr">{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="手机号：" prop="phone">
          <Input v-model="formInline.phone" placeholder="请输入手机号" />
        </FormItem>
        <FormItem label="国家：" prop="country">
          <Select v-model="formInline.country" placeholder="请选择国家" filterable>
            <Option v-for="(item, index) in countryList" :key="item.name" :value="item.name">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="地区：" prop="area" v-if="formInline.country === '中国'">
          <Cascader v-model="formInline.area" filterable placeholder="输入关键词进行地区搜索" :data="provinceArr"></Cascader>
        </FormItem>
        <FormItem label="详细地址：" prop="addressDetails">
          <Input v-model="formInline.addressDetails" placeholder="请输入详细地址" />
        </FormItem>
      </Form>
      <div class="f-tac submit-btn">
        <Button type="primary" size="large" long @click="handleSubmit" :loading="loading">确认并提交</Button>
      </div>
    </div>
    <div class="copyright">
      <p>Copyright &copy; {{ new Date().getFullYear() }} 国药励展展览有限责任公司 备案序号：京ICP备06050757号-7
        互联网药品信息服务资格证书证书编号:(京)经营性-2020-0007</p>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { provinces } from "@/other/provinces";
import gSwiper from "@components/gSwiper/gSwiper.vue";
import copyright from "@components/copyright/copyright.vue";
import { mapActions } from "vuex";
export default {
  name: 'live-user-reg',
  components: {
    gSwiper,
    copyright,
  },
  props: {},
  data () {
    let that = this;
    const zhValid = (rule, value, callback) => {
      if (/^[\u4e00-\u9fa5]+$/.test(value)) {
        callback();
      } else {
        callback(new Error('姓名格式有误'));
      }
    };
    const areaValid = (rule, value, callback) => {
      if (that.formInline.country === '中国') {
        if (!that.formInline.area.length) {
          callback(new Error('地区不能为空'));
        } else {
          callback();
        }
      } else {

        callback();
      }
    };
    return {
      userInfo: null,
      loading: false,
      mobile: false,
      list: [],
      countryList: [],
      provinceArr: [],
      departmentArr: [],
      jobTitleArr: [],
      formInline: {
        // form双向绑定
        name: "", // 姓名 
        gender: "",
        companyName: "",
        department: "",
        jobTitle: "",
        phone: "",
        country: "中国",
        area: [],
        addressDetails: '',
      },
      ruleInline: {
        // 效验规则
        name: [
          { required: true, message: "请输入姓名", trigger: "change" }
        ],
        gender: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "change" },
        ],
        department: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        jobTitle: [
          { required: true, message: "请选择职务", trigger: "change" },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change",
          },
          ...validator.phone
        ],
        country: [
          { required: true, message: "国家不能为空", trigger: "change" }
        ],
        area: [
          { required: true, validator: areaValid, trigger: "change" }
        ],
      }
    };
  },
  watch: {},
  computed: {
    query () {
      return this.$route.query;
    },
    channelId () {
      return this.query.channelId;
    },
    userId () {
      return this.query.userId;
    },
    activityId () {
      return this.query.activityId;
    },
  },
  methods: {
    ...mapActions({
      getDetailNoAuth: 'getDetailNoAuth',
      authSign: 'liveModule/authSign',
      getDepartmentJobs: 'liveModule/getDepartmentJobs',
      getDepartmentList: 'liveModule/getDepartmentList',
      getLiveLiveViewer: 'liveModule/getLiveLiveViewer',
      createOrUpdate: "liveModule/createOrUpdate",
      getBannerList: "liveModule/getBannerList", 
      getCountryList: "exhibitionModule/getCountryList",
      getCityByParentId: 'exhibitionModule/getCityByParentId',
      liveBroadcastUserSummary: "liveModule/liveBroadcastUserSummary", //   直播人员统计
    }),
    async init () {
      let countryList = await this.getCountryList();
      if (countryList && countryList.length > 0) {
        this.countryList = countryList;
      }
      let list = await this.getBannerList();
      this.list = list || [];
      let department = await this.getDepartmentList();
      this.departmentArr = department || []
      console.log(department, 'department');
      if (!this.userId) return;
    //   let user = await this.getDetailNoAuth(this.userId);
      let user = await this.getLiveLiveViewer(this.userId);
      this.userInfo = user || null;
      console.log('getDetailNoAuth', this.userInfo);
      if (!this.userInfo) return;
      this.formInline.name = this.userInfo.name || '';
      this.formInline.country = this.userInfo.country || '中国';
      this.formInline.companyName = this.userInfo.companyName || '';
    //   this.formInline.department = this.userInfo.department || '';
      this.formInline.phone = this.userInfo.phoneNumber || '';
      this.formInline.addressDetails = this.userInfo.addressDetails || '';
    //   this.formInline.jobTitle = this.userInfo.jobTitle || '';
      this.formInline.gender = this.userInfo.gender || '';
      if (this.userInfo.province && this.userInfo.city && this.userInfo.county) {
        this.formInline.area = [this.userInfo.province, this.userInfo.city, this.userInfo.county];
      }
    //   // gender 0未知 1男性 2 女性
    //   if (this.userInfo.gender === 0) {
    //     this.formInline.gender = 'unknown';
    //   }
    //   if (this.userInfo.gender === 1) {
    //     this.formInline.gender = 'male';
    //   }
    //   if (this.userInfo.gender === 2) {
    //     this.formInline.gender = 'female';
    //   }
    },
    async handleSubmit () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let form = this.formInline;
      let valid = await this.validForm('formInline');
      if (!valid) return;
      let option = {
        userId: this.userId,
        name: form.name,
        gender: form.gender,
        companyName: form.companyName,
        department: form.department,
        jobTitle: form.jobTitle,
        phoneNumber: form.phone,
        country: form.country,
        province: form.area[0],
        city: form.area[1],
        county: form.area[2],
        addressDetails: form.addressDetails,
      };
      console.log('option', option);

      let bool = await this.createOrUpdate(option);
      this.loading = false;
      if (bool) {
        this.$Message.success("操作成功");
        // 添加  直播人员统计
        this.liveUserTotal();
        // 跳转到 直播间
        this.liveHandle();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async changeJobs (e) {
      this.departmentArr.forEach(c => {
        if (c.name === e) {
          this.jobTitleArr = c.jobs || [];
          this.formInline.jobTitle = '';
        }
      });
      console.log('jobTitleArr', this.jobTitleArr);
    },



    async liveUserTotal () {
      let opt = { userId: this.userId, activityId: this.activityId };
      let res = await this.liveBroadcastUserSummary(opt);
      if (res ) {
      }
    },


    async liveHandle () {
      let userId = this.userId.replace(/-/g, '_',).toLocaleLowerCase();
      let opt = { userid: this.userId, channelId: this.channelId };
      let re = await this.authSign(opt);
      if (re && re.sign) {
        let url = `https://0c97b022f4.live.polyv.cn/watch/${this.channelId}?userid=${userId}&ts=${re.ts}&sign=${re.sign}`;
        window.location.replace(url);
      }
    }
  },
  async created () {

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true;
    }
    this.provinceArr = provinces.data;
    this.init();
  },
  mounted () {
    if (!this.userId || !this.channelId) {
        debugger
      let errText = ''
      if (!this.userId) {
        errText = '缺失用户id，确认链接是否正确'
      }
      if (!this.channelId) {
        errText = '缺失直播间id，确认链接是否正确'
      }
      this.$Message.error(errText);
      return;
    }
  }
}

</script>

<style lang="scss" scoped>
.my-swiper {
  /deep/ .ivu-carousel-list {
    font-size: 0;
  }
}

.mobile {
  .formbox {
    margin-top: 0;
    height: inherit;
    padding-bottom: 70px;

    h4 {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
}

.formbox {
  margin: 60px auto 120px;
  max-width: 800px;
  min-height: 954px;
  background-color: #fff;
  border-radius: 10px;

  h4 {
    font-size: 20px;
    color: #333;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 35px;
  }
}

.copyright {
  margin: 20px;
  color: #aaa;
  font-size: 12px;
  text-align: center;

  p {
    opacity: 0.7;
    margin: 0;
  }
}

.submit-btn {
  max-width: 500px;
  margin: 70px auto 0;
  padding: 0 20px 40px;
}

.my-form {
  max-width: 500px;
  margin: auto;
  padding: 0 20px;
}
</style>
